import { useState } from 'react';
import { ChevronRight, X } from 'lucide-react';

const STORAGE_KEY = 'epc-team-flowhint-dismissed';

/* Role legend chips — Sovereign Emerald role inks (must match the org-chart diagram). */
const CHIPS = [
  { col: '#0B3B2E', label: 'G' }, // Governance — racing green
  { col: '#8A5A08', label: 'H' }, // Dept Head — deep champagne
  { col: '#339274', label: 'M' }, // Manager — brand green
  { col: '#5A6275', label: 'E' }, // Site Engineer — neutral
];

export function EpcTeamFlowHint({ storageKey = STORAGE_KEY }: { storageKey?: string }) {
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(storageKey) === '1';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      /* ignore storage failures */
    }
    setDismissed(true);
  };

  return (
    <div
      className="flex flex-wrap items-center gap-2 rounded-xl px-3 py-2 text-[11px] text-[#7C8A82]"
      style={{ border: '1px dashed rgba(11,59,46,0.28)', background: 'rgba(250,247,238,0.7)' }}
    >
      <span className="font-bold uppercase tracking-[0.12em] text-[#2A1F17]">Flow</span>
      <span className="inline-flex items-center gap-1">
        {CHIPS.map((c, i) => (
          <span key={c.label} className="inline-flex items-center gap-1">
            {i > 0 ? <ChevronRight className="h-3 w-3 text-[#C9A961]" aria-hidden="true" /> : null}
            <span
              className="flex h-[18px] w-[18px] items-center justify-center rounded-full text-[9px] font-black text-white"
              style={{ background: c.col }}
            >
              {c.label}
            </span>
          </span>
        ))}
      </span>
      <span>Governance → Dept Heads → Managers → Site Engineers</span>
      <button
        type="button"
        aria-label="Dismiss flow hint"
        onClick={dismiss}
        className="ml-auto rounded-md p-0.5 text-[#C9A961] transition-colors hover:bg-[rgba(11,59,46,0.06)] hover:text-[#1F5A47]"
      >
        <X className="h-3.5 w-3.5" aria-hidden="true" />
      </button>
    </div>
  );
}
